import {ProductRecommendations} from 'hec/components/product-recommendations'
import PropTypes from 'prop-types'
import React from 'react'

export const BuilderProductRecommendations = ({
    attributes,
    podId,
    addedToCartPodId,
    slidesVisible,
    isAddToCart = false,
    productIds = [],
    groupId,
    isCategory,
    categoryId
}) => {
    return (
        <ProductRecommendations
            podId={podId}
            slidesVisible={slidesVisible}
            isAddToCart={isAddToCart}
            addedToCartPodId={addedToCartPodId}
            productIds={productIds}
            groupId={groupId}
            isCategory={isCategory}
            categoryId={categoryId}
            attributes={attributes}
            data-testid="ProductRecommendations"
        />
    )
}

BuilderProductRecommendations.propTypes = {
    attributes: PropTypes.object,
    podId: PropTypes.string,
    slidesVisible: PropTypes.object,
    isAddToCart: PropTypes.bool,
    addedToCartPodId: PropTypes.string,
    productIds: PropTypes.array,
    groupId: PropTypes.string,
    isCategory: PropTypes.bool,
    categoryId: PropTypes.string,
    accountFormLabels: PropTypes.object.isRequired
}

export const ProductRecommendationsDefinition = {
    component: BuilderProductRecommendations,
    name: 'Product Recommendations',
    noWrap: true,
    defaultStyles: {
        flexDirection: 'row',
        position: 'relative',
        flexShrink: '0',
        boxSizing: 'border-box',
        marginTop: '20px',
        marginLeft: '102px',
        marginRight: '102px'
    },
    inputs: [
        {
            name: 'isCategory',
            type: 'boolean',
            default: false
        },
        {
            name: 'categoryId',
            type: 'string',
            showIf: `options.get('isCategory')`
        },
        {
            name: 'podId',
            type: 'string',
            helperText: 'The constructor pod identifier for the recommendations pod (i.e "pdp-2")',
            showIf: `!options.get('isCategory')`
        },
        {
            name: 'groupId',
            type: 'string',
            helperText:
                'The constructor group Id identifier for the recommendations pod (i.e "suncare")',
            showIf: `!options.get('isCategory')`
        },
        {
            name: 'addedToCartPodId',
            type: 'string',
            helperText: 'The Added To Cart constructor pod identifier(i.e "pdp-2")',
            required: true
        },
        {
            name: 'slidesVisible',
            type: 'object',
            required: true,
            subFields: [
                {
                    name: 'onDesktop',
                    type: 'string',
                    defaultValue: '4'
                },
                {
                    name: 'onMobile',
                    type: 'string',
                    defaultValue: '2'
                }
            ]
        }
    ]
}
